import { PortableTextBlock } from 'next-sanity'

/**
 * Converts a plain text string to a PortableTextBlock array
 * for use with Sanity's PortableText component
 */
export function toPortableTextBlock(text: string, key: string): PortableTextBlock[] {
  return [
    {
      _type: 'block' as const,
      _key: key,
      style: 'normal' as const,
      children: [{ _type: 'span' as const, _key: `${key}s`, text, marks: [] as string[] }],
      markDefs: [] as never[],
    },
  ]
}
